import { ComplextRoute } from 'router/components/Routes/Routes';
import VendorForm from './pages/VendorForm';

export default [
  {
    index: true,
    element: VendorForm,
  },
] as Array<ComplextRoute>;
